export const SUIVI_RECLAMATION = {
    SET_ITEMS: 'SET_SUIVI_RECLAMATION_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_RECLAMATION_ITEMS',
    SET_ITEM: 'SET_SUIVI_RECLAMATION_ITEM',
    RESET_ITEMS: 'SUIVI_RECLAMATION_RESET_ITEMS',

    SET_PAGE: 'SET_SUIVI_RECLAMATION_PAGE',
    SET_NB_OF_PAGES: 'SET_SUIVI_RECLAMATION_NB_OF_PAGES',
    SET_SCROLL: 'SET_SUIVI_RECLAMATION_SCROLL',

    SET_SORT: 'SET_SUIVI_RECLAMATION_SORT',
    SET_COUNT: 'SET_SUIVI_RECLAMATION_COUNT',
    SET_FILTER_STATUS: 'SUIVI_RECLAMATION_SET_FILTER_STATUS',
    RESET_FILTER: 'SUIVI_RECLAMATION_RESET_FILTER',
    SET_FILTER_INTERVENTION_ID: 'SUIVI_RECLAMATION_SET_FILTER_INTERVENTION_ID',
    SET_FILTER_ONLY_MINE: 'SUIVI_RECLAMATION_SET_FILTER_ONLY_MINE',
    ADD_FILTER_SITE: 'SUIVI_RECLAMATION_ADD_FILTER_SITE',
    REMOVE_FILTER_SITE: 'SUIVI_RECLAMATION_REMOVE_FILTER_SITE',
    SET_FILTER_SITE: 'SUIVI_RECLAMATION_SET_FILTER_SITE',
    ADD_FILTER_STATUS: 'SUIVI_RECLAMATION_ADD_FILTER_STATUS',
    REMOVE_FILTER_STATUS: 'SUIVI_RECLAMATION_REMOVE_FILTER_STATUS',

    SET_IS_LOADING: 'SET_SUIVI_RECLAMATION_IS_LOADING',
    SET_ERROR: 'SET_SUIVI_RECLAMATION_ERROR',

    SET_HISTORIQUE: 'SET_HISTORIQUE_ITEMS',
    ADD_HISTORIQUE_ITEM: 'ADD_HISTORIQUE_ITEM',

    RESET: 'RESET_SUIVI_RECLAMATION',

    SET_EXPORT_RECLAMATION_IS_LOADING: 'SET_EXPORT_RECLAMATION_IS_LOADING'
};
